import React, { useEffect, useState, useRef } from "react";
import styles from "./Header.module.css";
import logo from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useCMS } from "../Context/CmsContext";
import SearchModal from "./SearchModal";

const Header = () => {
  const navigate = useNavigate();
  const { cmsData } = useCMS();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [isSearchFocused, setIsSearchFocused] = useState(false); // Track if search box is focused
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Refs to track the search box and dropdown
  const searchBoxRef = useRef(null);
  const searchResultsRef = useRef(null);

  const handleHomePageNavaigation = () => {
    navigate("/");
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredResults([]); // Clear results when search term is empty
    } else {
      setFilteredResults(
        cmsData.filter((item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery, cmsData]);

  // Handle clicking outside search box and dropdown to clear the search query
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target) &&
        searchResultsRef.current &&
        !searchResultsRef.current.contains(event.target)
      ) {
        setSearchQuery(""); // Clear the search query if clicked outside
        setFilteredResults([]); // Clear the filtered results
        setIsSearchFocused(false); // Remove focus from the search box
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectResult = (service, title, id) => {
    const encodedTitle = encodeURIComponent(title);
    navigate(`/${service}/${encodedTitle}/${id}`);
    setSearchQuery("");
    setFilteredResults([]);
    setIsSearchFocused(false); // Remove focus after selecting a result
  };

  // Function to handle Internet Banking button click
  const handleInternetBankingClick = () => {
    window.open("https://inet.khattri.bank.in/ibs-jsp/", "_blank"); // Open link in a new tab
  };

  return (
    <>
      <div className={styles.mainHeaderBox}>
        <div className={styles.headerBoxTop}>
          <div className={styles.logoBox}>
            <img
              src={logo}
              alt="logo"
              className={styles.logoImage}
              onClick={handleHomePageNavaigation}
            />
          </div>
          <div className={styles.bankName}>
            <h4 onClick={handleHomePageNavaigation}>
              The Khattri Co-operative Urban Bank LTD.
            </h4>
            <p>
              Regd. Office – 24, Darya Ganj, New Delhi – 110 002.
              +91-011-41251490
              <br />
              Email – ho@khattribank.com, information@khattribank.com
            </p>
          </div>
          {/* Replace the images div with the Internet Banking button */}
          <div className={styles.internetBankingButton}>
            <button onClick={handleInternetBankingClick}>
              Click for Internet Banking
            </button>
          </div>
          <div className={styles.menuItems}>
            <div className={styles.searchEnglish}>
              <div
                className={styles.searchBox}
                onClick={() => setIsModalOpen(true)} // 🔥 open modal
              >
                <div className={styles.searchIcon}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                <div className={styles.searchInput}>
                  <input
                    type="text"
                    placeholder="Search..."
                    // value={searchQuery}
                    onClick={() => setIsModalOpen(true)}
                    // onChange={handleInputChange}
                    // onFocus={() => setIsSearchFocused(true)}
                    readOnly
                  />
                </div>
              </div>

              {/* ✅ Keep results inside same relative container */}
              {/* {filteredResults.length > 0 && (
                <div className={styles.searchResults} ref={searchResultsRef}>
                  {filteredResults.map((item) => (
                    <div
                      key={item.id}
                      className={styles.searchResultItem}
                      onClick={() =>
                        handleSelectResult(item.service, item.title, item.id)
                      }
                    >
                      {item.title}
                    </div>
                  ))}
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <SearchModal
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          results={filteredResults}
          onSelect={handleSelectResult}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default Header;
